// Uncomment the following lines to import the desired Bootstrap JavaScript components

import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';

import './index.scss';

document.addEventListener('DOMContentLoaded', () => import('shared/toasts/toasts'));

// initialize tooltips
document.addEventListener('DOMContentLoaded', () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  if (tooltipTriggerList.length > 0)
    import('bootstrap/js/dist/tooltip').then(({ default: Tooltip }) =>
      tooltipTriggerList.forEach(
        tooltipTriggerEl => new Tooltip(tooltipTriggerEl, { container: 'main' })
      )
    );
});

// validate terms acceptance for sign in form
document.addEventListener('DOMContentLoaded', () => {
  const signInForm = document.querySelector('form[action*="login"]') as HTMLFormElement;
  const linkedInForm = document.querySelector('form[action*="lnkd_redirect"]') as HTMLFormElement;
  const termsCheckbox = document.getElementById('user_terms_of_service') as HTMLInputElement;

  if (!signInForm || !linkedInForm || !termsCheckbox) return;

  const validateTermsAcceptance = (event: Event): void => {
    if (!termsCheckbox.checked) {
      event.preventDefault();
      termsCheckbox.classList.add('is-invalid');
    }
  };

  const resetTermsAcceptance = (): void => {
    if (termsCheckbox.checked) termsCheckbox.classList.remove('is-invalid');
  };

  termsCheckbox.addEventListener('change', resetTermsAcceptance);
  signInForm.addEventListener('submit', validateTermsAcceptance);
  linkedInForm.addEventListener('submit', validateTermsAcceptance);
});

// Handle navbar background color when scrolling away from top of page
// and hide or show the scroll down indicator
document.addEventListener('DOMContentLoaded', () => {
  const homepageNavbar = document.querySelector('.navbar.homepage');
  const scrollDownIndicator = document.getElementById('scroll-down-indicator');

  if (!homepageNavbar) return;

  const sentinel = document.createElement('div');
  sentinel.style.position = 'absolute';
  sentinel.style.top = '50px';
  sentinel.style.height = '1px';
  sentinel.style.width = '1px';
  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        homepageNavbar.classList.remove('text-bg-dark', 'shadow');
        if (scrollDownIndicator) scrollDownIndicator.style.opacity = '1';
      } else {
        homepageNavbar.classList.add('text-bg-dark', 'shadow');
        if (scrollDownIndicator) scrollDownIndicator.style.opacity = '0';
      }
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);

  const carousels = document.querySelectorAll('[id^="carousel-"]');
  import('bootstrap/js/dist/carousel').then(({ default: Carousel }) => {
    carousels.forEach(
      carousel =>
        new Carousel(carousel, {
          keyboard: true,
          touch: true
        })
    );
  });
});

// Load idea and fund profile PDFs when their respective modals open
document.addEventListener('show.bs.modal', e => {
  const iframe = (e.target as HTMLElement).querySelector<HTMLIFrameElement>('iframe[data-src]');
  if (iframe?.dataset.src) iframe.src = iframe.dataset.src;
});

// Randomly places and moves the hero orbs around the homepage hero section
document.addEventListener('DOMContentLoaded', () => {
  const orbs = document.querySelectorAll<HTMLElement>('.hero-orb');

  if (orbs.length === 0) return;

  orbs.forEach(orb => {
    orb.style.top = `${Math.random() * 80 - 10}%`;
    orb.style.left = `${Math.random() * 80 - 10}%`;

    let currentX = Math.random() * 80 - 40;
    let currentY = Math.random() * 80 - 40;
    let targetX = Math.random() * 80 - 40;
    let targetY = Math.random() * 80 - 40;
    let progress = 0;
    const speed = 0.00015 + Math.random() * 0.0002;

    orb.style.transform = `translate(${currentX}%, ${currentY}%) scale(1)`;

    let lastTime = performance.now();

    function update(now: number): void {
      const delta = now - lastTime;
      lastTime = now;
      progress += delta * speed;

      if (progress >= 1) {
        currentX = targetX;
        currentY = targetY;
        targetX = Math.random() * 80 - 40;
        targetY = Math.random() * 80 - 40;
        progress = 0;
      }

      const t =
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      const x = currentX + (targetX - currentX) * t;
      const y = currentY + (targetY - currentY) * t;
      const scale = 0.9 + Math.sin(now * 0.0005) * 0.15;

      orb.style.transform = `translate(${x}%, ${y}%) scale(${scale})`;
      requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  });
});
